import { MirrorService } from 'services/MirrorService';

import { AdsFloatingBubblePopup } from 'components/shared/Popups/AdsFloatingBubblePopup';
import { AdsVideoPopup } from 'components/shared/Popups/AdsVideoPopup';
import { BuyStickerPopup } from 'components/shared/Popups/BuyStickerPopup';
import { InitStickerPopup } from 'components/shared/Popups/InitStickerPopup';
import { InterstitialPopup } from 'components/shared/Popups/InterstitialPopup';
import { LimitTimeOfferPopup } from 'components/shared/Popups/LimitTimeOfferPopup';
import { MyLikesPopup } from 'components/shared/Popups/MyLikesPopup';
import { MyVisitsPopup } from 'components/shared/Popups/MyVisitsPopup';
import { PerfectMatchPopup } from 'components/shared/Popups/PerfectMatchPopup';
import { PromoteVipPopup } from 'components/shared/Popups/PromoteVipPopup';
import { StopExitPopup } from 'components/shared/Popups/StopExitPopup';
import { UploadPhotoPopup } from 'components/shared/Popups/UploadPhotoPopup';
import { UserProfileUnlockPopup } from 'components/shared/Popups/UserProfileUnlockPopup';

import { PopupItem, PopupNames } from './types';

export const POPUP_EVENT_NAME = 'POPUP_EVENT';
export const POPUP_QUEUE_STORAGE_KEY = 'POPUP_QUEUE';
export const POPUP_QUEUE_DELAY = 10000; // 10 sec

const basePopups = [
  { name: PopupNames.AdsFloatingBubble, component: AdsFloatingBubblePopup },
  { name: PopupNames.AdsVideo, component: AdsVideoPopup },
  { name: PopupNames.MyVisits, component: MyVisitsPopup },
  { name: PopupNames.MyLikes, component: MyLikesPopup },
  { name: PopupNames.PromoteVip, component: PromoteVipPopup },
  { name: PopupNames.PerfectMatch, component: PerfectMatchPopup },
  { name: PopupNames.UploadPhoto, component: UploadPhotoPopup },
  { name: PopupNames.UserProfileUnlock, component: UserProfileUnlockPopup },
];

const additionalPopups = [
  { name: PopupNames.BuySticker, component: BuyStickerPopup },
  { name: PopupNames.InitSticker, component: InitStickerPopup },
  { name: PopupNames.Interstitial, component: InterstitialPopup },
  { name: PopupNames.LimitTimeOffer, component: LimitTimeOfferPopup },
  { name: PopupNames.StopExist, component: StopExitPopup },
];

export const REGISTER_POPUPS: PopupItem[] = MirrorService.isDescriptorGroupId
  ? [...basePopups]
  : [...basePopups, ...additionalPopups];
